<template>
  <div class="nodes-list-container">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('nodelist.cnode')" name="first">
        <cnode-nav :list="c_data"></cnode-nav>
      </el-tab-pane>
      <el-tab-pane :label="$t('nodelist.nnode')" name="second">
        <cnode-nav :list="n_data"></cnode-nav>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CnodeNav from "./Cnode";
export default {
  name: "Nodelist",
  components: {
    CnodeNav,
  },
  computed: {
    nodelist() {
      return this.$store.getters.NodeList || [];
    },
    offnodelist() {
      return this.$store.getters.offNodeList || [];
    },
    annualList() {
      return this.$store.getters.annualList || [];
    },
  },
  data() {
    return {
      activeName: "first",
      c_data: [],
      n_data: [],
      historyAnnualList: [
        {
          public_key:
            "022bf80145bd448d993abffa237f4cd06d9df13eaad37afce5cb71d80c47b03feb",
          annual: "3.76%",
        },
        {
          public_key:
            "03c8f63775536eb420c96228cdccc9de7d80e87f1b562a6eb93c0838064350aa53",
          annual: "3.76%",
        },
        {
          public_key:
            "0253719ac66d7cafa1fe49a64f73bd864a346da92d908c19577a003a8a4160b7fa",
          annual: "3.76%",
        },
        {
          public_key:
            "02bcdd278a27e4969d48de95d6b7b086b65b8d1d4ff6509e7a9eab364a76115af7",
          annual: "3.76%",
        },
        {
          public_key:
            "02765d98bb092962734e365bd436bdc80c5b5991dcf22b28dbb02d3b3cf74d6444",
          annual: "3.76%",
        },
        {
          public_key:
            "0251f06bc247b1da94ec7d9fe25f5f913cedaecba8524140353b826cf9b1cbd9f4",
          annual: "3.76%",
        },
        {
          public_key:
            "022e911fb5a20b4b2e4f917f10eb92f27d17cad16b916bce8fd2dd8c11ac2878c0",
          annual: "3.76%",
        },
      ],
    };
  },
  watch: {
    offnodelist: function() {
      this.getNodeList();
    },
    nodelist: function() {
      for (let i = 0; i < this.nodelist.length; i++) {
        for (let j = 0; j < this.offnodelist.length; j++) {
          if (this.nodelist[i].public_key == this.offnodelist[j].public_key) {
            this.nodelist[i].region = this.offnodelist[j].region;
            this.nodelist[i].social_media = this.offnodelist[j].social_media;
            this.nodelist[i].website = this.offnodelist[j].website;
            this.nodelist[i].verification = this.offnodelist[j].verification;
            this.nodelist[i].contact_info_verified = this.offnodelist[
              j
            ].contact_info_verified;
            this.nodelist[i].old_node = this.offnodelist[j].old_node;
            this.nodelist[i].fee_sharing_ratio = this.offnodelist[
              j
            ].fee_sharing_ratio;
            this.nodelist[i].ontology_harbinger = this.offnodelist[
              j
            ].ontology_harbinger;
            this.nodelist[i].bad_actor = this.offnodelist[j].bad_actor;
            this.nodelist[i].risky = this.offnodelist[j].risky;
            this.nodelist[i].annual = this.getAnnual(
              this.nodelist[i].public_key
            );
          }
        }
        if (this.nodelist[i].status == 2) {
          this.c_data.push(this.nodelist[i]);
        }
        if (this.nodelist[i].status == 1) {
          this.n_data.push(this.nodelist[i]);
        }
      }
    },
  },
  mounted() {
    this.getoffNodeList();
    this.getAnnualList();
  },
  methods: {
    getNodeList() {
      this.$store.dispatch("getNodeList").then();
    },
    getoffNodeList() {
      this.$store.dispatch("getOffNodeList").then();
    },
    getAnnualList() {
      this.$store.dispatch("getAnnualList").then();
    },
    getAnnual($publicKey) {
      let flag = false;
      let annual = "";
      let list;
      let time = Date.parse(new Date());
      let timeFlag = false;
      if (time < 1594051680000) {
        list = this.historyAnnualList;
        timeFlag = false;
      } else {
        list = this.annualList.records;
        timeFlag = true;
      }
      for (var i = 0; i < list.length; i++) {
        if ($publicKey == list[i].public_key) {
          if (timeFlag) {
            annual =
              parseFloat(list[i].user_gas_fee_incentive_rate) +
              parseFloat(list[i].user_released_ong_incentive_rate) +
              parseFloat(list[i].user_foundation_bonus_incentive_rate);
            annual = annual.toFixed(2) + "%";
            flag = true;
          } else {
            annual = list[i].annual;
            flag = true;
          }
        }
      }
      if (!flag) {
        annual = "not open";
      }
      return annual;
    },
  },
};
</script>
<style lang="scss" scoped>
.nodes-list-container {
  width: 100%;
  background-color: #f3f6f8;
  padding: 120px;
  box-sizing: border-box;

  @include mobile {
    padding: 40px 0;
  }
}
::v-deep .el-tabs__nav-wrap {
  padding-left: 20px;
}
</style>
